import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AuthAlert } from '@webapp/account/src/components/auth';
import { ExpiredModal } from '@webapp/account/src/components/auth/modals/expired/expired-modal';
import { CopyTemplate } from '@webapp/account/src/pages/copy-template';
import { GetFile } from '@webapp/account/src/pages/get-file';
import { UserStatus } from '@webapp/account/src/resources/profile/profile';
import {
    selectProfile,
    selectProfileAuthSuccess,
    selectProfileLoading,
    selectProfileRestricted,
    selectUserStatus,
} from '@webapp/account/src/resources/profile/selectors';
import { accountRoutes, AccountRoutes, surveyRoutes } from '@webapp/account/src/resources/routes';

import { CustomStylesCtx, customStylesInitial } from '@webapp/common/components/custom-styles';
import { Loader } from '@webapp/common/components/loader';
import { lazy } from '@webapp/common/lib/lazy';
import { LocalStorage, LocalStorageKeys } from '@webapp/common/lib/storage';

import css from './app.css';

const AccountCon = lazy(() => import('@webapp/account/src/pages/account'));
const NotFoundPage = lazy(() => import('@webapp/common/components/not-found-page'));
const SurveyContainer = lazy(() => import('@webapp/account/src/pages/survey'));

export const Account: FC = () => {
    const authSuccess = useSelector(selectProfileAuthSuccess);
    const profileLoading = useSelector(selectProfileLoading);
    const profileRestricted = useSelector(selectProfileRestricted);
    const { deviceConfirmed } = useSelector(selectProfile);
    const userStatus = useSelector(selectUserStatus);

    useEffect(() => {
        window.ttgrafSetWidgetParams?.({
            id: 579384,
        });
    }, []);

    if (profileLoading) {
        return <Loader className={css.loader} visible={true} />;
    }

    if (!authSuccess) {
        if (deviceConfirmed) {
            return <Redirect to={AccountRoutes.authLogin.link} />;
        }
        LocalStorage.set(LocalStorageKeys.BACK_URL, `backUrl=${window.location.pathname}`);
        return <Redirect to={AccountRoutes.authConfirmDeviceRequest.link} />;
    }

    if (userStatus === UserStatus.BLOCKED) {
        return <ExpiredModal />;
    }

    if (profileRestricted) {
        return <AuthAlert />;
    }

    return (
        <CustomStylesCtx.Provider value={customStylesInitial}>
            <Switch>
                <Route exact component={AccountCon} path={AccountRoutes.account.link} />
                <Route component={AccountCon} path={AccountRoutes.folder.link} />
                <Route component={AccountCon} path={accountRoutes} />
                <Route component={SurveyContainer} path={surveyRoutes} />
                <Route component={GetFile} path={AccountRoutes.getFile.link} />
                <Route exact component={CopyTemplate} path={AccountRoutes.copyTemplate.link} />
                <Route component={NotFoundPage} />
            </Switch>
        </CustomStylesCtx.Provider>
    );
};
